import { onClickOutside } from "../common/helpers";

const HEIGHT = 0;
const MAX_HEIGHT = 600;

const toPixels = (value) => `${value}px`;

const initElement = ($el) => {
    const $input = $el.querySelector(".ns-multiselect__input");
    const $title = $el.querySelector(".ns-multiselect__title");
    const $dropdown = $el.querySelector(".ns-multiselect__dropdown");
    const checkboxes = $el.querySelectorAll(".ns-checkbox__input");
    let isOpened = false;

    const handleOpen = () => {
        if ($el.classList.contains("ns-multiselect--disabled")) {
            return;
        }
        $title.setAttribute("aria-expanded", "true");
        $dropdown.removeAttribute("inert");
        $el.classList.add("ns-multiselect--active");
        $dropdown.style.maxHeight = toPixels(MAX_HEIGHT);
    };

    const handleClose = () => {
        $title.setAttribute("aria-expanded", "false");
        $dropdown.setAttribute("inert", "true");
        $el.classList.remove("ns-multiselect--active");
        $dropdown.style.maxHeight = HEIGHT;
    };

    const dispatchOnChange = (value) => {
        $el.dispatchEvent(
            new CustomEvent("on-change", {
                detail: {
                    value,
                },
            })
        );
    };

    const setValue = (value = []) => {
        const title = $title.dataset.title;

        $input.value = value.join(",");

        if (title) {
            if (value.length === 0) {
                $title.textContent = $title.ariaLabel = title;
            } else if (value.length === 1) {
                $title.textContent = $el.querySelector(
                    `.ns-checkbox__input[value='${value}']`
                ).dataset.textValue;
                $title.ariaLabel = `${title}: ${$title.textContent}`;
            } else {
                $title.textContent = `${value.length} ${title}`;
                $title.ariaLabel = `${title}: ${$title.textContent}`;
            }
        }

        dispatchOnChange(value);
    };

    const handleAddValue = (value) => {
        const currentValue = $input.value ? $input.value.split(",") : [];
        const nextValue = [...currentValue, value];
        const $checkbox = $el.querySelector(`[value="${value}"]`);

        if (!$checkbox) {
            return;
        }

        $checkbox.checked = true;

        setValue(nextValue);
    };

    const handleRemoveValue = (value) => {
        const currentValue = $input.value ? $input.value.split(",") : [];
        const nextValue = currentValue.filter((v) => v !== value);
        const $checkbox = $el.querySelector(`[value="${value}"]`);

        if (!$checkbox) {
            return;
        }

        $checkbox.checked = false;

        setValue(nextValue);
    };

    const handleClearValue = () => {
        setValue([]);

        checkboxes.forEach(($checkbox) => {
            $checkbox.checked = false;
        });

        dispatchOnChange("");
    };

    const handleChange = (event, $checkbox) => {
        const value = $checkbox.value;

        if (event.currentTarget.checked) {
            handleAddValue(value);
        } else {
            handleRemoveValue(value);
        }
    };

    $title.addEventListener("click", () => {
        if (isOpened === false) {
            handleOpen();
        } else {
            handleClose();
        }

        isOpened = !isOpened;
    });

    onClickOutside($el, () => {
        handleClose();

        isOpened = false;
    });

    checkboxes.forEach(($checkbox) => {
        $checkbox.addEventListener("change", (event) => {
            handleChange(event, $checkbox);
        });
    });

    $el.addEventListener("handle-remove-value", ({ detail }) => {
        const { value } = detail;

        if (!value) {
            return;
        }

        handleRemoveValue(value);
    });

    $el.addEventListener("handle-add-value", ({ detail }) => {
        const { value } = detail;

        if (!value) {
            return;
        }

        handleAddValue(value);
    });

    $el.addEventListener("handle-clear-value", handleClearValue);
};

const initElementMobile = ($el) => {
    const title = $el.querySelector(".ns-multiselect-mobile__title");
    const tag = title.dataset.tag;
    const frame = document.querySelector(
        `.ns-multiselect-mobile__frame[data-tag='${tag}']`
    );
    const back = frame.querySelector(".ns-multiselect-mobile__frame-top-back");
    const selectAll = frame.querySelector(
        ".ns-multiselect-mobile__frame-top-all-select"
    );
    const deselectAll = frame.querySelector(
        ".ns-multiselect-mobile__frame-top-all-deselect"
    );
    const inputs = frame.querySelectorAll(".ns-checkbox__input");
    const confirmSelection = frame.querySelector(
        ".ns-multiselect-mobile__frame-confirm"
    );
    let isOpened = false;

    const handleOpen = () => {
        if ($el.classList.contains("ns-multiselect-mobile--disabled")) {
            return;
        }

        frame.classList.add("ns-multiselect-mobile__frame--active");
        isOpened = true;
    };

    const handleBack = () => {
        frame.classList.remove("ns-multiselect-mobile__frame--active");
        isOpened = false;
    };

    const handleSelectAll = () => {
        const notInputsChecked = frame.querySelectorAll(
            ".ns-checkbox__input:not(:checked)"
        );

        for (const notInputChecked of notInputsChecked) {
            notInputChecked.click();
        }
    };

    const handleDeselectAll = () => {
        const inputsChecked = frame.querySelectorAll(
            ".ns-checkbox__input:checked"
        );

        for (const inputChecked of inputsChecked) {
            inputChecked.click();
        }
    };

    const handleChange = (event) => {
        const countInputsChecked = frame.querySelectorAll(
            ".ns-checkbox__input:checked"
        ).length;

        if (countInputsChecked === inputs.length) {
            selectAll.style.display = "none";
            deselectAll.style.display = "block";
        } else {
            selectAll.style.display = "block";
            deselectAll.style.display = "none";
        }
    };

    title.addEventListener("click", handleOpen);
    back.addEventListener("click", handleBack);
    selectAll.addEventListener("click", handleSelectAll);
    deselectAll.addEventListener("click", handleDeselectAll);

    for (const input of inputs) {
        input.addEventListener("change", handleChange);
    }

    confirmSelection.addEventListener("click", handleBack);
};

const init = () => {
    const multiselects = document.querySelectorAll(
        ".ns-multiselect:not(.ns-multiselect__big)"
    );
    const multiselectsMobile = document.querySelectorAll(
        ".ns-multiselect-mobile:not(.ns-multiselect-mobile--big)"
    );

    multiselects.forEach(($el) => {
        initElement($el);
    });
    multiselectsMobile.forEach(($el) => {
        initElementMobile($el);
    });
};

window.addEventListener("DOMContentLoaded", init, false);
